import { useMemo } from 'react';

export function useTypeGuard<Sub extends Super, Super>(
	item: Super,
	check: (item: Super) => item is Sub
): Nullable<Sub> {
	return useMemo(() => {
		if (!check(item)) {
			return null;
		}
		return item;
	}, [check, item]);
}
